import { render, staticRenderFns } from "./artificialAppeal.vue?vue&type=template&id=7f5e64ab&scoped=true&"
import script from "./artificialAppeal.vue?vue&type=script&lang=js&"
export * from "./artificialAppeal.vue?vue&type=script&lang=js&"
import style0 from "./artificialAppeal.vue?vue&type=style&index=0&id=7f5e64ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5e64ab",
  null
  
)

export default component.exports